import * as React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";


let countryCode = 'au'; // default
try {
    countryCode = document.querySelector('[data-block="country-selector"]')
                    .querySelector('[data-js="current-country"]').dataset.countryCode;
}
catch (e) {
    console.error("Problem selecting current country");
}

let tcLink = "";
let countryStoreCountDesc = "";
switch (countryCode.toLowerCase()){
    case "au":
        tcLink = "https://www.bedbathntable.com.au/terms";
        break;
    case "nz":
        tcLink = "https://www.bedbathntable.co.nz/terms";
        break;
    default:
        tcLink = "https://www.bedbathntable.com.au/terms";
        break;
};

class ModalSubHeaderComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { productName } = this.props;
    return (
      <div className="find-in-store-form">
        <div className="pure-g center">
          <div className="pure-u-1">
            <h1 className="title">FIND IN STORE</h1>
          </div>
        </div>
        <div className="pure-g center sub-header">
          <div className="pure-u-1">
            <p>
              Checking availability for&nbsp;
              <span className="productName">{productName}</span>&nbsp;
            </p>
          </div>
          <div className="pure-u-1">
            <p className="header-info">
              Please note that all results are indicative only, as stock levels are constantly changing. Refer to our <a className="bbnt-giftcard-link" href={tcLink} target="_blank">terms and conditions.</a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

ModalSubHeaderComponent.propTypes = {

};

export default ModalSubHeaderComponent;
